import React from "react";
import { Link } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import SideNav from '../../shared/Sidenav';
import Button from "../../shared/Button";
import add from '../../../assets/images/add.svg';
import edit from '../../../assets/images/edit.svg';
import deleteIcon from '../../../assets/images/delete_enable.svg';
import deletedisable from '../../../assets/images/delete_disable.svg';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import info from '../../../assets/images/info.svg';
import '../../../css/manageServices/ManageServices.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServiceType from './AddServiceTypeModal.js';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceDeliveryBaseURL } from '../../../Services/config/apiGateway';
import { CONFIGURESERVICE_ENDPOINT } from '../../../Services/config/apiEndPoints';
import DeleteModal from '../../shared/DeleteRoleModal';
import SuccessModal from '../../shared/SuccessModal';
import FieldsForRequester from './FieldsForRequester';
import { connect } from 'react-redux';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
toast.configure();
let viewOnly = true;
class ManageServices extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasOpen: false,
            manageServicesData: [],
            editIndex: '',
            hasOpenDelete: false,
            confirmedHasOpen: false,
            deleteIndex: '',
            viewFieldsForRequester: false,
            isEdit: false,
        }
    }
    componentDidMount = () => {
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 27) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        ApiCall(
            'GET',
            serviceDeliveryBaseURL + CONFIGURESERVICE_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!'); apiData.sort(function (a, b) {
                        return b.serviceId - a.serviceId
                    })
                    this.setState({ manageServicesData: apiData })
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    getTime = (timeStamp) => {
        return new Date(Number(timeStamp)).toString().split(' ')[4].substring(0, 5);
    }
    getPublishDate = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    getDate = (dateString) => {
        //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
        let dateParts = dateString.split("/");
        // month is 0-based, that's why we need dataParts[1] - 1
        let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
        window.location.reload();
    };
    onAddHandleUser = () => {
        this.setState({ hasOpen: true });
    }
    onEditHandleUser = (index) => {
        this.setState({ editIndex: index, isEdit: true, hasOpen: true })
    }
    onCloseDeleteModal = () => {
        this.setState({ hasOpenDelete: false });
    }
    confirmDelete = (index) => {
        ApiCall(
            'DELETE',
            serviceDeliveryBaseURL + CONFIGURESERVICE_ENDPOINT + `?serviceId=${this.state.manageServicesData[this.state.deleteIndex].serviceId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            },
        ).then((apiData) => {
            if (apiData.flag !== -1) {
                if (apiData.flag === 500) {
                    // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                }
                else {
                    console.log('I am 200!');
                    this.setState({ confirmedHasOpen: true });
                    this.setState({ hasOpenDelete: false });
                }
            } else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        });
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    onDeleteManageService = (index) => {
        console.log("delete index", index);
        this.setState({ deleteIndex: index, hasOpenDelete: true });
    }
    manageServiceDescription = (serviceDescription) => {
        let element;
        let descriptionArray = [];
        for (let index = 0; index < serviceDescription.length; index++) {
            if (index <= 50) {
                element = serviceDescription[index];
                descriptionArray.push(element)
            }
        }
        return descriptionArray.join("") + "..."
    }
    madantoryFieldsData = (fields) => {
        let element;
        let fieldsArray = [];
        let stringArray = [];
        fields.map((data) => {
            if (data.fieldType == 'Mandatory') {
                fieldsArray.push(data.fieldName)
            }
        })
        let fieldsLength = fieldsArray.toString();
        if (fieldsLength.length >= 40) {
            for (let index = 0; index < fieldsLength.length; index++) {
                if (index <= 40) {
                    element = fieldsLength[index];
                    stringArray.push(element)
                }
            }
            return stringArray.join('') + "...";
        }
        else {
            return fieldsArray.join(', ');
        }
    }
    optionalFieldsData = (fields) => {
        let element;
        let fieldsArray = [];
        let stringArray = [];
        fields.map((data) => {
            if (data.fieldType != 'Mandatory') {
                fieldsArray.push(data.fieldName)
            }
        })
        let fieldsLength = fieldsArray.toString();
        if (fieldsLength.length >= 30) {
            for (let index = 0; index < fieldsLength.length; index++) {
                if (index <= 30) {
                    element = fieldsLength[index];
                    stringArray.push(element)
                }
            }
            return stringArray.join('') + "...";
        }
        else {
            return fieldsArray.join(', ');
        }
    }
    optionalFieldsTooltipData = (fields) => {
        let fieldsArray = [];
        fields.map((data) => {
            if (data.fieldType != 'Mandatory') {
                fieldsArray.push(data.fieldName)
            }
        })
        return fieldsArray.join(', ');
    }
    madantoryFieldsTooltipData = (fields) => {
        let fieldsArray = [];
        fields.map((data) => {
            if (data.fieldType == 'Mandatory') {
                fieldsArray.push(data.fieldName)
            }
        })
        return fieldsArray.join(', ');
    }
    renderTableData() {
        return this.state.manageServicesData.map((details, index) => {
            return ( 
                // (details.serviceType === "Generic" || details.serviceType === "Non-generic") &&
                <>
                    <tr key={index} id="manageServicesdata">
                        <td className="tabledata" id="servicebodySno">{index + 1}</td>
                        <td className="tabledata" id="serviceTypebody">{details.serviceName}</td>
                        <td className="tabledata" id="serviceDescriptionbody">
                            <div data-tip={details.description}>{details.description.length < 50 ? details.description : this.manageServiceDescription(details.description)}</div>
                        </td>
                        <td className="tabledata" id="bodyEffectivedt">{this.getPublishDate(details.effectiveDate)} {this.getTime(details.effectiveDate)}</td>
                        <td className="tabledata" id="bodyMandatoryFields" >
                            <div data-tip={this.madantoryFieldsTooltipData(details.dataFields)}>{this.madantoryFieldsData(details.dataFields)}</div>
                            <ReactTooltip place="bottom" effect='solid' arrowColor="#6F6F6F" backgroundColor="#6F6F6F" multiline={true} className="serviceDescriptionReactTooltip" />
                        </td>
                        <td className="tabledata" id="bodyOptionalFields">
                            <div data-tip={this.optionalFieldsTooltipData(details.dataFields)}>{this.optionalFieldsData(details.dataFields)}</div>
                        </td>
                        <td className={details.feesConfiguredFlag == true ? "hidden" : "infoColumn"} 
                        // style={{ visibility: details.feesConfiguredFlag == true ? "hidden" : null }}
                        >
                            <img alt="info" src={info} data-tip="Transaction Fees is not added for this service."
                            />
                        </td>
                        <td className="editDelete" style={{ display: !viewOnly ? "none" : null }}>
                            <div id="partition"><img src={edit} alt="" onClick={() => { this.onEditHandleUser(index) }} /></div></td>
                        <td className="editDelete" style={{ display: !viewOnly ? "none" : null }}>
                            <div className="deleteAd">
                                <img src={details.serviceId === 3 ? deletedisable : deleteIcon} onClick={details.serviceId === 3 ? null : () => this.onDeleteManageService(index)} alt="" />
                            </div>
                        </td>
                    </tr>
                </>
            )
        })
    }
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="serviceSno" className="tableHeaderText">S. No.</td>
                    <td id="serviceType" className="tableHeaderText">Service Type</td>
                    <td id="serviceDescription" className="tableHeaderText">Service Description</td>
                    <td id="effectivedt" className="tableHeaderText">Effective Date & Time </td>
                    <td id="mandatoryFields" className="tableHeaderText">Mandatory Fields</td>
                    <td id="optionalFields" className="tableHeaderText">Optional Fields</td>
                    <td className="infoColumn" style={{ display: this.state.manageServicesData.map(details => details.feesConfiguredFlag == true) ? "none" : "flex" }}></td>
                    <td style={{ display: !viewOnly ? "none" : "flex" }}></td>
                    <td style={{ display: !viewOnly ? "none" : "flex" }}></td>
                </tr>
            </>
        )
    }
    render() {
        return (
            <div className="outer1" ><div className="outer1" id="outerdiv" >
                <MetaDecorator title={TitleDescription.manageServicesPageTitle} description={TitleDescription.manageServicesPageDescription} />
                <div className="mshome">
                    <SideNav />
                    <div id="manageServicesPart" >
                        <div className="manageServicesHeading">
                            <h1 id='manageServicestitle'>Manage Services</h1>
                            <Button class="viewFields" onClick={() => this.setState({ viewFieldsForRequester: true })}>Fields For Requester</Button>
                        </div>
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <div className="servicescontentbox">
                            <table>
                                <thead className="servicesHeading">
                                    {this.renderTableHeader()}
                                </thead>
                            </table>
                            <div className="servicesContent">
                                <table id='details'>
                                    <tbody >
                                        {this.renderTableData()}
                                    </tbody>
                                </table>
                            </div>
                            <div id="servicesTableFooter" style={{ display: !viewOnly ? "none" : "flex" }}>
                                <Link onClick={this.onAddHandleUser}><img src={add} alt="" width="19" height="19" id="addServiceType" /> <small className="addServiceTypeText">Add Service Type</small></Link>
                            </div>
                            <div className="serviceFooter">
                                <div>
                                    <small class="manageServicesNoteText">Note:</small>
                                </div>
                                <small class="manageServicesNoteOne">1. Any new service added here will be visible to Requesters and Respondents on CC only after the transaction fees will be updated by Admin for that service under
Transaction fees tile.</small>
                                <div>
                                    <small class="manageServicesNoteTwo">2. Once Admin update the transaction fees, Respondent will be notified about this newly added service so that they can update in their profile if they are
interested to provide this service.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.hasOpen ? <ServiceType onClick={this.onCloseModal} onClosePublish={this.onCloseModal}
                    editMode={this.state.isEdit} editValue={this.state.manageServicesData[this.state.editIndex]}
                /> : null}
                <DeleteModal hasOpen={this.state.hasOpenDelete} onClick={this.onCloseDeleteModal} onYesClick={this.confirmDelete} >
                    <p className="deletemodalText">Do you really want to delete this manage services?</p>
                </DeleteModal>
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmedText">Confirmed</p>
                </SuccessModal>
                {this.state.viewFieldsForRequester &&
                    <FieldsForRequester onClick={() => this.setState({ viewFieldsForRequester: false })} />
                }
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(ManageServices);